module.exports = __webpack_public_path__ + "img/commun_one.996e7acb.png";